<img alt="samedi GmbH" src="./assets/samedi-logo-blue.svg"><h1>Konfigurieren Sie Ihren samedi-Button!</h1><HelloWorld></HelloWorld>